import React from "react";
import { S3_URL } from "../api/api.main";
import { uploadData } from "aws-amplify/storage";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import qs from "qs";


export const getPathUrl = (key) => {
  return S3_URL + "/" + key;
};

export const FileType = {
  png: "image/png",
  jpeg: "image/jpeg",
  jpg: "image/jpg",
  mp4: "video/mp4",
  pdf: "application/pdf",
};

export const TypeFile = Object.keys(FileType).reduce((acc, key) => {
  const value = FileType[key];
  acc[value] = key;
  return acc;
}, {});

export const onImageUploadBefore = (files, info, core, uploadHandler) => {
  if (!files && files === null && files === undefined && files < 0) return;
  (async () => {
    const file = files[0];

    const keyUpload = `${new Date().getTime()}.${TypeFile[file.type]}`;

    await uploadData({
      key: keyUpload,
      data: file,
    }).result

    const responseUpload = {
      result: [
        {
          url: getPathUrl(keyUpload),
          name: files[0].name,
          size: files[0].size,
        },
      ],
    };

    await uploadHandler(responseUpload);
  })();
  uploadHandler();
};

export const ConverseDate = (inputDate = "2023-09-19") => {
  const date = new Date(inputDate.slice(0,10));

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${day} ${month} ${year}`;
  return formattedDate;
};

export const Postdate = ({text_size="12px" ,date="03 jul 2023"}) => {
  return (
    <div className="flex flex-row items-center">
      <div className={`text-viewnum text-[12px] max-md:text-[8px]`}>
        {"Posted on "+date}
      </div>
    </div>
  );
};

export const NEARBY_TYPE = {
  market:"ตลาด",
  study:"สถานศึกษา",
  station:"สถานีขนส่ง",
  mall:"ห้างสรรพสินค้า",
  touristPlace:"สถานที่ท่องเที่ยว",
  trainStation:"สถานีรถไฟ",
  industryZone:"นิคมอุตสาหกรรม",
  road:"ถนน",
  airport:"สนามบิน",
  hospital:"โรงพยาบาล",
  restaurant:"ร้านอาหาร",
  company:"บริษัท",
  exercisePlace:"สถานที่ออกกำลังกาย",
  park:"สวนสาธารณะ",
}

export const CATEGORY_CONVERT = {
  land: "ที่ดิน",
  singleHouse: "บ้านเดี่ยว",
  townHouse: "ทาวน์โฮม, ทาวน์เฮ้าส์",
  condo: "คอนโดมิเนียม",
  apartment: "อพาร์ทเมนท์",
  businessBuilding: "อาคารพาณิชย์",
  hotel: "โรงแรม, รีสอร์ท",
  office: "พื้นที่สำนักงาน",
  factory: "โรงงาน, คลังสินค้า",
  etc:"อื่นๆ"
};

export const TYPE_CONVERT ={
  rent:"เช่า",
  sale:"ขาย",
  saleandrent:"ขายและเช่า"
};

export const STATUS_CONVERT = {
  avilable: "Public",
  sold:  "Sold"
}

export const AREA_CONVERT = {
  squaremeter:"ตารางเมตร",
  wa:"ตารางวา",
  rai: "ไร่"
}

export const DISTANCE_UNIT_CONVERT = {
  kilometer: "กิโลเมตร",
  meter: "เมตร"
}

export const CONVERT_TYPE= {
  news:"ข่าวสารองค์กร",
  articles:"บทความ"
}

export const IMG_URL = (imgName) =>{
  return S3_URL+"/"+imgName;
};

const cn = (...inputs) => {
  return twMerge(classNames(inputs));
};

const NEARBYICON_STYLE = "w-[24px] h-[24px] max-sm:w-[14px] max-sm:h-[14px]";

export const NEARBYICON = {
  study: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M12 7.2L18.4 10.4V23.2H5.6V10.4L12 7.2ZM12 7.2V0M0 23.2H24M2.4 23.2V13.6H5.6M21.6 23.2V13.6H18.4M10.4 23.2V18.4H13.6V23.2M12 0.8H16.8V4H12M12 15.2C11.5757 15.2 11.1687 15.0314 10.8686 14.7314C10.5686 14.4313 10.4 14.0243 10.4 13.6C10.4 13.1757 10.5686 12.7687 10.8686 12.4686C11.1687 12.1686 11.5757 12 12 12C12.4243 12 12.8313 12.1686 13.1314 12.4686C13.4314 12.7687 13.6 13.1757 13.6 13.6C13.6 14.0243 13.4314 14.4313 13.1314 14.7314C12.8313 15.0314 12.4243 15.2 12 15.2Z"
        stroke="black"
        stroke-width="1.5"
      />{" "}
    </svg>
  ),
  station: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="w-[24px] h-[24px] max-sm:w-[14px] max-sm:h-[14px]"
    >
      {" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.93 5C19.3901 4.99992 19.844 5.10568 20.2567 5.30907C20.6694 5.51247 21.0298 5.80807 21.31 6.173L21.426 6.336L22.496 7.941C22.7829 8.37121 22.9538 8.86829 22.992 9.384L23 9.606V16C23.0002 16.5046 22.8096 16.9906 22.4665 17.3605C22.1234 17.7305 21.6532 17.9572 21.15 17.995L21 18H20.83C20.6284 18.5703 20.2592 19.0663 19.7707 19.4231C19.2823 19.7799 18.6974 19.9808 18.0929 19.9994C17.4883 20.018 16.8922 19.8534 16.3827 19.5273C15.8733 19.2012 15.4743 18.7288 15.238 18.172L15.17 18H8.829C8.62722 18.57 8.25797 19.0657 7.76964 19.4222C7.28131 19.7788 6.69667 19.9795 6.09232 19.9981C5.48797 20.0167 4.8921 19.8523 4.38278 19.5264C3.87345 19.2006 3.47444 18.7285 3.238 18.172L3.17 18H3C2.49542 18.0002 2.00943 17.8096 1.63945 17.4665C1.26947 17.1234 1.04284 16.6532 1.005 16.15L1 16V8C0.999957 7.23479 1.29233 6.49849 1.81728 5.94174C2.34224 5.38499 3.06011 5.04989 3.824 5.005L4 5H18.93ZM18 16C17.7348 16 17.4804 16.1054 17.2929 16.2929C17.1054 16.4804 17 16.7348 17 17C17 17.2652 17.1054 17.5196 17.2929 17.7071C17.4804 17.8946 17.7348 18 18 18C18.2652 18 18.5196 17.8946 18.7071 17.7071C18.8946 17.5196 19 17.2652 19 17C19 16.7348 18.8946 16.4804 18.7071 16.2929C18.5196 16.1054 18.2652 16 18 16ZM6 16C5.73478 16 5.48043 16.1054 5.29289 16.2929C5.10536 16.4804 5 16.7348 5 17C5 17.2652 5.10536 17.5196 5.29289 17.7071C5.48043 17.8946 5.73478 18 6 18C6.26522 18 6.51957 17.8946 6.70711 17.7071C6.89464 17.5196 7 17.2652 7 17C7 16.7348 6.89464 16.4804 6.70711 16.2929C6.51957 16.1054 6.26522 16 6 16ZM16.268 12H3V16H3.17C3.3766 15.4145 3.75974 14.9074 4.2666 14.5488C4.77346 14.1901 5.37909 13.9975 6 13.9975C6.62091 13.9975 7.22654 14.1901 7.7334 14.5488C8.24026 14.9074 8.6234 15.4145 8.83 16H15.17C15.3766 15.4145 15.7597 14.9074 16.2666 14.5488C16.7735 14.1901 17.3791 13.9975 18 13.9975C18.6209 13.9975 19.2265 14.1901 19.7334 14.5488C20.2403 14.9074 20.6234 15.4145 20.83 16H21V13H18C17.6489 13 17.3041 12.9076 17 12.732C16.696 12.5565 16.4435 12.304 16.268 12ZM18.93 7H18V11H21V9.606C21 9.40847 20.9416 9.21535 20.832 9.051L19.762 7.445C19.6707 7.30808 19.5469 7.19583 19.4018 7.11821C19.2566 7.04058 19.0946 6.99998 18.93 7ZM6 7H4C3.75507 7.00003 3.51866 7.08996 3.33563 7.25272C3.15259 7.41547 3.03566 7.63975 3.007 7.883L3 8V10H6V7ZM11 7H8V10H11V7ZM16 7H13V10H16V7Z"
        fill="black"
      />{" "}
    </svg>
  ),
  mall: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="w-[24px] h-[24px] max-sm:w-[14px] max-sm:h-[14px]"
    >
      {" "}
      <path
        d="M22 8.16162L20.8676 15.3333C20.6618 16.7475 19.5294 17.6566 18.0882 17.6566H8.20588C6.86765 17.6566 5.63235 16.6465 5.42647 15.3333L4.19118 6.94949L3.88235 4.62626C3.77941 4.0202 3.26471 3.61616 2.54412 3.61616H1.82353C1.41176 3.61616 1 3.21212 1 2.80808C1 2.40404 1.41176 2 1.82353 2H2.54412C3.98529 2 5.22059 3.0101 5.32353 4.42424L5.52941 6.0404H20.1471C20.6618 6.0404 21.1765 6.24242 21.4853 6.64647C21.8971 7.05051 22 7.65657 22 8.16162Z"
        fill="black"
      />{" "}
      <path
        d="M18.2941 22C18.8626 22 19.3235 21.5478 19.3235 20.9899C19.3235 20.432 18.8626 19.9798 18.2941 19.9798C17.7256 19.9798 17.2647 20.432 17.2647 20.9899C17.2647 21.5478 17.7256 22 18.2941 22Z"
        fill="black"
      />{" "}
      <path
        d="M8 22C8.56853 22 9.02941 21.5478 9.02941 20.9899C9.02941 20.432 8.56853 19.9798 8 19.9798C7.43147 19.9798 6.97059 20.432 6.97059 20.9899C6.97059 21.5478 7.43147 22 8 22Z"
        fill="black"
      />{" "}
    </svg>
  ),
  touristPlace: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="w-[24px] h-[24px] max-sm:w-[14px] max-sm:h-[14px]"
    >
      {" "}
      <path
        d="M12 2C9.89206 1.99989 7.86926 2.83176 6.37124 4.31479C4.87323 5.79782 4.02108 7.81216 4 9.92C4 15.4 11.05 21.5 11.35 21.76C11.5311 21.9149 11.7616 22.0001 12 22.0001C12.2384 22.0001 12.4689 21.9149 12.65 21.76C13 21.5 20 15.4 20 9.92C19.9789 7.81216 19.1268 5.79782 17.6288 4.31479C16.1307 2.83176 14.1079 1.99989 12 2ZM12 19.65C10.33 18.06 6 13.65 6 9.92C6 8.3287 6.63214 6.80258 7.75736 5.67736C8.88258 4.55214 10.4087 3.92 12 3.92C13.5913 3.92 15.1174 4.55214 16.2426 5.67736C17.3679 6.80258 18 8.3287 18 9.92C18 13.62 13.67 18.06 12 19.65Z"
        fill="black"
      />{" "}
      <path
        d="M12 6C11.3078 6 10.6311 6.20527 10.0555 6.58986C9.47993 6.97444 9.03133 7.52107 8.76642 8.16061C8.50152 8.80015 8.4322 9.50388 8.56725 10.1828C8.7023 10.8618 9.03564 11.4854 9.52513 11.9749C10.0146 12.4644 10.6383 12.7977 11.3172 12.9327C11.9961 13.0678 12.6999 12.9985 13.3394 12.7336C13.9789 12.4687 14.5256 12.0201 14.9101 11.4445C15.2947 10.8689 15.5 10.1922 15.5 9.5C15.5 8.57174 15.1313 7.6815 14.4749 7.02513C13.8185 6.36875 12.9283 6 12 6ZM12 11C11.7033 11 11.4133 10.912 11.1666 10.7472C10.92 10.5824 10.7277 10.3481 10.6142 10.074C10.5007 9.79994 10.4709 9.49834 10.5288 9.20736C10.5867 8.91639 10.7296 8.64912 10.9393 8.43934C11.1491 8.22956 11.4164 8.0867 11.7074 8.02882C11.9983 7.97094 12.2999 8.00065 12.574 8.11418C12.8481 8.22771 13.0824 8.41997 13.2472 8.66665C13.412 8.91332 13.5 9.20333 13.5 9.5C13.5 9.89782 13.342 10.2794 13.0607 10.5607C12.7794 10.842 12.3978 11 12 11Z"
        fill="black"
      />{" "}
    </svg>
  ),
  trainStation: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M4 15.5V6.00001C4 5.11667 4.22933 4.41234 4.688 3.88701C5.14667 3.36167 5.75067 2.96167 6.5 2.68701C7.25 2.41234 8.10433 2.22901 9.063 2.13701C10.0217 2.04501 11.0007 1.99934 12 2.00001C13.1 2.00001 14.1377 2.04601 15.113 2.13801C16.0883 2.23001 16.9383 2.41334 17.663 2.68801C18.3877 2.96267 18.9583 3.36267 19.375 3.88801C19.7917 4.41334 20 5.11734 20 6.00001V15.5C20 16.4833 19.6627 17.3127 18.988 17.988C18.3133 18.6633 17.484 19.0007 16.5 19L18 20.5V21H16L14 19H10L8 21H6V20.5L7.5 19C6.51667 19 5.68733 18.6627 5.012 17.988C4.33667 17.3133 3.99933 16.484 4 15.5ZM6 10H11V7.00001H6V10ZM13 10H18V7.00001H13V10ZM8.5 16C8.93333 16 9.29167 15.8583 9.575 15.575C9.85833 15.2917 10 14.9333 10 14.5C10 14.0667 9.85833 13.7083 9.575 13.425C9.29167 13.1417 8.93333 13 8.5 13C8.06667 13 7.70833 13.1417 7.425 13.425C7.14167 13.7083 7 14.0667 7 14.5C7 14.9333 7.14167 15.2917 7.425 15.575C7.70833 15.8583 8.06667 16 8.5 16ZM15.5 16C15.9333 16 16.2917 15.8583 16.575 15.575C16.8583 15.2917 17 14.9333 17 14.5C17 14.0667 16.8583 13.7083 16.575 13.425C16.2917 13.1417 15.9333 13 15.5 13C15.0667 13 14.7083 13.1417 14.425 13.425C14.1417 13.7083 14 14.0667 14 14.5C14 14.9333 14.1417 15.2917 14.425 15.575C14.7083 15.8583 15.0667 16 15.5 16Z"
        fill="black"
      />{" "}
    </svg>
  ),
  industryZone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      <path
        d="M21.5278 4.5L15.375 10.5797V4.5H13.7566L7.875 10.4656V0.75H0.75V23.25H23.25V4.5H21.5278ZM21.75 21.75H2.25V2.25H6.375V12.375H8.09897L13.875 6.51647V12.375H15.6921L21.75 6.38906V21.75Z"
        fill="black"
      />
      <path
        d="M6.375 15.375V15.75H7.875V14.25H6.375V15.375ZM6.375 17.625H7.875V19.125H6.375V17.625ZM10.125 15.375V15.75H11.625V14.25H10.125V15.375ZM10.125 17.625H11.625V19.125H10.125V17.625ZM13.875 15.375V15.75H15.375V14.25H13.875V15.375ZM13.875 17.625H15.375V19.125H13.875V17.625ZM17.625 14.25H19.125V15.75H17.625V14.25ZM17.625 17.625H19.125V19.125H17.625V17.625Z"
        fill="black"
      />
    </svg>
  ),
  road: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M10 2L8 8H11V2H10ZM13 2V8H16L14 2H13ZM2 9V10H4V11H6V10H18L18.06 11H20V10H22V9H2ZM7 11L3.34 22H11V11H7ZM13 11V22H20.66L17 11H13Z"
        fill="black"
      />{" "}
    </svg>
  ),
  airport: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M20.5595 3.91156C21.1495 4.50156 21.1495 5.45156 20.5595 6.03156L16.6695 9.92156L18.7895 19.1116L17.3795 20.5316L13.4995 13.1016L9.59945 17.0016L9.95945 19.4716L8.88945 20.5316L7.12945 17.3516L3.93945 15.5816L4.99945 14.5016L7.49945 14.8716L11.3695 11.0016L3.93945 7.09156L5.35945 5.68156L14.5495 7.80156L18.4395 3.91156C18.9995 3.33156 19.9995 3.33156 20.5595 3.91156Z"
        fill="black"
      />{" "}
    </svg>
  ),
  market: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.263 6C8.885 6 8.548 6.262 8.418 6.656L6.11 13.667C6.03713 13.8887 5.99999 14.1206 6 14.354V17.143C6 18.72 7.151 20 8.571 20C9.991 20 11.143 18.72 11.143 17.143C11.143 18.721 12.294 20 13.714 20C15.134 20 16.286 18.72 16.286 17.143C16.286 18.721 17.437 20 18.857 20C20.277 20 21.427 18.722 21.429 17.145C21.429 18.722 22.58 20 24 20C25.42 20 26.571 18.72 26.571 17.143C26.571 18.721 27.723 20 29.143 20C30.563 20 31.713 18.722 31.714 17.145C31.715 18.722 32.866 20 34.286 20C35.706 20 36.857 18.72 36.857 17.143C36.857 18.721 38.008 20 39.429 20C40.849 20 42 18.72 42 17.143V14.354C42 14.1206 41.9629 13.8887 41.89 13.667L39.582 6.657C39.452 6.262 39.115 6 38.737 6H9.263Z"
        fill="black"
      />{" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 21.23V29H7.5C7.36739 29 7.24021 29.0527 7.14645 29.1464C7.05268 29.2402 7 29.3674 7 29.5V30.5C7 30.6326 7.05268 30.7598 7.14645 30.8536C7.24021 30.9473 7.36739 31 7.5 31H40.5C40.6326 31 40.7598 30.9473 40.8536 30.8536C40.9473 30.7598 41 30.6326 41 30.5V29.5C41 29.3674 40.9473 29.2402 40.8536 29.1464C40.7598 29.0527 40.6326 29 40.5 29H38V21.23C37.5814 21.0632 37.1947 20.8254 36.857 20.527C36.5977 20.7556 36.3096 20.9493 36 21.103V29H12V21.103C11.6904 20.9493 11.4023 20.7556 11.143 20.527C10.807 20.822 10.423 21.062 10 21.23ZM36 19.273C36.085 19.188 36.165 19.097 36.24 19H36V19.273ZM37.474 19C37.6252 19.1959 37.8021 19.3705 38 19.519V19H37.474ZM10 19.519C10.1989 19.3716 10.376 19.1969 10.526 19H10V19.519ZM11.76 19H12V19.273C11.9141 19.1874 11.8339 19.0962 11.76 19ZM8.5 33C8.36739 33 8.24021 33.0527 8.14645 33.1464C8.05268 33.2402 8 33.3674 8 33.5V41C8 41.2652 8.10536 41.5196 8.29289 41.7071C8.48043 41.8946 8.73478 42 9 42H39C39.2652 42 39.5196 41.8946 39.7071 41.7071C39.8946 41.5196 40 41.2652 40 41V33.5C40 33.3674 39.9473 33.2402 39.8536 33.1464C39.7598 33.0527 39.6326 33 39.5 33H8.5Z"
        fill="black"
      />{" "}
      <path
        d="M14 26.5C14 26.3674 14.0527 26.2402 14.1464 26.1464C14.2402 26.0527 14.3674 26 14.5 26H17.5C17.6326 26 17.7598 26.0527 17.8536 26.1464C17.9473 26.2402 18 26.3674 18 26.5V28.5C18 28.6326 17.9473 28.7598 17.8536 28.8536C17.7598 28.9473 17.6326 29 17.5 29H14.5C14.3674 29 14.2402 28.9473 14.1464 28.8536C14.0527 28.7598 14 28.6326 14 28.5V26.5Z"
        fill="black"
      />{" "}
      <path
        d="M16 27.5C16 27.3674 16.0527 27.2402 16.1464 27.1464C16.2402 27.0527 16.3674 27 16.5 27H19.5C19.6326 27 19.7598 27.0527 19.8536 27.1464C19.9473 27.2402 20 27.3674 20 27.5V28.5C20 28.6326 19.9473 28.7598 19.8536 28.8536C19.7598 28.9473 19.6326 29 19.5 29H16.5C16.3674 29 16.2402 28.9473 16.1464 28.8536C16.0527 28.7598 16 28.6326 16 28.5V27.5ZM24 27.5C24 27.8978 23.842 28.2794 23.5607 28.5607C23.2794 28.842 22.8978 29 22.5 29C22.1022 29 21.7206 28.842 21.4393 28.5607C21.158 28.2794 21 27.8978 21 27.5C21 27.1022 21.158 26.7206 21.4393 26.4393C21.7206 26.158 22.1022 26 22.5 26C22.8978 26 23.2794 26.158 23.5607 26.4393C23.842 26.7206 24 27.1022 24 27.5Z"
        fill="black"
      />{" "}
    </svg>
  ),
  hospital: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M16 5.5H20L22 10.5H2L4 5.5H8M12 14.5H8V21.5H12M12 14.5V21.5M12 14.5H16V21.5H12M10.5 6.5H13.5M18 21.5H6M12 8V5M4 10.5H20V21.5H4V10.5ZM8 2.5H16V10.5H8V2.5Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
    </svg>
  ),
  restaurant: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M19 18H5.00003M12 18V12M15 18V14M9.00003 18V14M19 22V11.33C19.3714 11.1947 19.7123 10.9873 20.0033 10.7199C20.2943 10.4525 20.5295 10.1302 20.6956 9.77155C20.8617 9.41293 20.9553 9.02504 20.9711 8.63014C20.9869 8.23524 20.9245 7.84111 20.7875 7.47039C20.6505 7.09967 20.4417 6.75965 20.173 6.46986C19.9043 6.18007 19.5809 5.94621 19.2216 5.78171C18.8622 5.61721 18.4739 5.52531 18.079 5.51129C17.684 5.49727 17.2901 5.5614 16.92 5.7C16.55 3.874 14.46 2 12 2C9.54003 2 7.45003 3.874 7.08003 5.7C6.33345 5.42417 5.50787 5.45623 4.78492 5.7891C4.06197 6.12198 3.50086 6.72842 3.22503 7.475C2.94921 8.22158 2.98126 9.04716 3.31414 9.77011C3.64701 10.4931 4.25345 11.0542 5.00003 11.33V22H19Z"
        stroke="black"
        stroke-width="2"
      />{" "}
    </svg>
  ),
  company: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M2.8125 26.25H27.1875M4.6875 3.75V26.25M17.8125 3.75V26.25M25.3125 9.375V26.25M8.4375 8.4375H9.375M8.4375 12.1875H9.375M8.4375 15.9375H9.375M13.125 8.4375H14.0625M13.125 12.1875H14.0625M13.125 15.9375H14.0625M8.4375 26.25V22.0312C8.4375 21.255 9.0675 20.625 9.84375 20.625H12.6562C13.4325 20.625 14.0625 21.255 14.0625 22.0312V26.25M3.75 3.75H18.75M17.8125 9.375H26.25M21.5625 14.0625H21.5725V14.0725H21.5625V14.0625ZM21.5625 17.8125H21.5725V17.8225H21.5625V17.8125ZM21.5625 21.5625H21.5725V21.5725H21.5625V21.5625Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
    </svg>
  ),
  exercisePlace: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M23.2008 11.1984V12.7984H21.6008V15.9984H20.0008V17.5984H17.6008V12.7984H6.40078V17.5984H4.00078V15.9984H2.40078V12.7984H0.800781V11.1984H2.40078V7.99844H4.00078V6.39844H6.40078V11.1984H17.6008V6.39844H20.0008V7.99844H21.6008V11.1984H23.2008Z"
        fill="black"
      />{" "}
    </svg>
  ),
  park: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M21.75 17.9995H18.75V15.7495H21C21.114 15.7495 21.2264 15.7235 21.3288 15.6736C21.4313 15.6236 21.5209 15.5509 21.5911 15.4611C21.6612 15.3712 21.7099 15.2666 21.7336 15.1551C21.7572 15.0436 21.7551 14.9282 21.7275 14.8177L18.7275 2.81767C18.6869 2.6555 18.5932 2.51156 18.4614 2.40871C18.3296 2.30586 18.1672 2.25 18 2.25C17.8328 2.25 17.6704 2.30586 17.5386 2.40871C17.4068 2.51156 17.3131 2.6555 17.2725 2.81767L14.2725 14.8177C14.2449 14.9282 14.2428 15.0436 14.2664 15.1551C14.2901 15.2666 14.3388 15.3712 14.4089 15.4611C14.4791 15.5509 14.5687 15.6236 14.6712 15.6736C14.7736 15.7235 14.886 15.7495 15 15.7495H17.25V17.9995H11.25V16.4995H12C12.1989 16.4995 12.3897 16.4205 12.5303 16.2799C12.671 16.1392 12.75 15.9485 12.75 15.7495C12.75 15.5506 12.671 15.3599 12.5303 15.2192C12.3897 15.0786 12.1989 14.9995 12 14.9995H11.25V13.4995H12C12.1989 13.4995 12.3897 13.4205 12.5303 13.2799C12.671 13.1392 12.75 12.9485 12.75 12.7495C12.75 12.5506 12.671 12.3599 12.5303 12.2192C12.3897 12.0786 12.1989 11.9995 12 11.9995H3.75C3.55109 11.9995 3.36032 12.0786 3.21967 12.2192C3.07902 12.3599 3 12.5506 3 12.7495C3 12.9485 3.07902 13.1392 3.21967 13.2799C3.36032 13.4205 3.55109 13.4995 3.75 13.4995H4.5V14.9995H3.75C3.55109 14.9995 3.36032 15.0786 3.21967 15.2192C3.07902 15.3599 3 15.5506 3 15.7495C3 15.9485 3.07902 16.1392 3.21967 16.2799C3.36032 16.4205 3.55109 16.4995 3.75 16.4995H4.5V17.9995H2.25C2.05109 17.9995 1.86032 18.0786 1.71967 18.2192C1.57902 18.3599 1.5 18.5506 1.5 18.7495C1.5 18.9485 1.57902 19.1392 1.71967 19.2799C1.86032 19.4205 2.05109 19.4995 2.25 19.4995H21.75C21.9489 19.4995 22.1397 19.4205 22.2803 19.2799C22.421 19.1392 22.5 18.9485 22.5 18.7495C22.5 18.5506 22.421 18.3599 22.2803 18.2192C22.1397 18.0786 21.9489 17.9995 21.75 17.9995ZM18 6.0933L20.0391 14.2495H15.9609L18 6.0933ZM6 13.4995H9.75V14.9995H6V13.4995ZM6 16.4995H9.75V17.9995H6V16.4995ZM10.875 8.99955C11.3942 8.99955 11.9017 8.84559 12.3334 8.55715C12.7651 8.26872 13.1015 7.85875 13.3002 7.37909C13.4989 6.89943 13.5508 6.37163 13.4496 5.86243C13.3483 5.35323 13.0983 4.8855 12.7312 4.51839C12.364 4.15128 11.8963 3.90127 11.3871 3.79999C10.8779 3.6987 10.3501 3.75068 9.87046 3.94936C9.3908 4.14804 8.98083 4.4845 8.69239 4.91617C8.40395 5.34785 8.25 5.85537 8.25 6.37455C8.25 7.07074 8.52656 7.73842 9.01884 8.2307C9.51113 8.72298 10.1788 8.99955 10.875 8.99955ZM10.875 5.24955C11.0975 5.24955 11.315 5.31553 11.5 5.43914C11.685 5.56276 11.8292 5.73846 11.9144 5.94403C11.9995 6.14959 12.0218 6.37579 11.9784 6.59402C11.935 6.81225 11.8278 7.01271 11.6705 7.17004C11.5132 7.32738 11.3127 7.43452 11.0945 7.47793C10.8762 7.52134 10.65 7.49906 10.4445 7.41391C10.2389 7.32876 10.0632 7.18457 9.9396 6.99956C9.81598 6.81456 9.75 6.59705 9.75 6.37455C9.75 6.07618 9.86853 5.79003 10.0795 5.57905C10.2905 5.36807 10.5766 5.24955 10.875 5.24955Z"
        fill="black"
      />{" "}
    </svg>
  ),
  pier: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={NEARBYICON_STYLE}
    >
      {" "}
      <path
        d="M7.5 7.5H22.5V12.45L15 10L7.5 12.45M4.925 23.75H5C7 23.75 8.75 22.65 10 21.25C11.25 22.65 13 23.75 15 23.75C17 23.75 18.75 22.65 20 21.25C21.25 22.65 23 23.75 25 23.75H25.0625L27.4375 15.3875C27.5375 15.075 27.5 14.725 27.3625 14.425C27.2 14.125 26.9375 13.9 26.6125 13.8L25 13.275V7.5C25 6.83696 24.7366 6.20107 24.2678 5.73223C23.7989 5.26339 23.163 5 22.5 5H18.75V1.25H11.25V5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V13.275L3.3875 13.8C3.0625 13.9 2.8 14.125 2.6375 14.425C2.5 14.725 2.4625 15.075 2.5625 15.3875M25 26.25C23.2625 26.25 21.525 25.6625 20 24.5875C16.95 26.725 13.05 26.725 10 24.5875C8.475 25.6625 6.7375 26.25 5 26.25H2.5V28.75H5C6.7125 28.75 8.425 28.3125 10 27.5C13.125 29.125 16.875 29.125 20 27.5C21.575 28.3125 23.275 28.75 25 28.75H27.5V26.25H25Z"
        fill="black"
      />{" "}
    </svg>
  ),
};

export const ImgFromFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
};

export const ConQs = (query) => {
  return qs.stringify(query);
}

export const convertPhone = (myValue) => {
  const phonrItems = myValue.split("");
  let FormNumber =
    phonrItems.slice(0, 3).join("") +
    "-" +
    phonrItems.slice(3, 6).join("") +
    "-" +
    phonrItems.slice(6, 11).join("");
  return FormNumber;
};

// export default ImgFromFile;